import { MagnifyingGlassIcon } from '@heroicons/react/24/solid';
import { Button, Tooltip } from 'react-daisyui';
import { useTranslation } from 'react-i18next';
import { useChatSearchContext } from './ChatSearch.context';
import { shortcutModifierLabel } from './ChatSearch.shortcut';

/**
 * The magnifier that opens "Buscar en esta conversación". It lives in the
 * ChatMenu action row, right after the block button, and is built exactly like
 * its siblings there (react-daisyui ghost outline, 36 px, 20 px solid icon).
 * The tooltip is the one place the shortcut is taught. A click opens the bar
 * growing out of it; Ctrl/⌘+F opens it at once (ChatSearchShortcut).
 *
 * Renders nothing outside a ChatSearchProvider, i.e. with the feature off.
 */
export default function ChatSearchOpenButton() {
  const chatSearch = useChatSearchContext();
  const { t } = useTranslation('chat/chat');

  if (!chatSearch) return null;

  return (
    <Tooltip
      message={t('chatSearch.openTitle', { shortcut: shortcutModifierLabel() })}
      position="bottom"
    >
      <Button
        ref={chatSearch.openButtonRef}
        color="ghost"
        variant="outline"
        size="sm"
        className="ChatMenu__Buttons__Box"
        aria-label={t('chatSearch.open')}
        data-testid="chat-search-open"
        onClick={() => chatSearch.open({ animate: true, trigger: 'button' })}
      >
        <MagnifyingGlassIcon className="ChatMenu__Button__Icon" />
      </Button>
    </Tooltip>
  );
}
